var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { active: _vm.showInstaller, "can-cancel": false, scroll: "keep" },
      on: {
        "update:active": function ($event) {
          _vm.showInstaller = $event
        },
        close: _vm.cancelar,
      },
    },
    [
      _c("b-loading", {
        attrs: { "is-full-page": false, "can-cancel": true },
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-content" }, [
          _c("h1", { staticClass: "title is-4" }, [
            _c("i", { staticClass: "fas fa-cube" }),
            _vm._v(" Instalación: Autoridad de Registro"),
          ]),
          _vm._v(" "),
          _c("h1", { staticClass: "subtitle is-6" }, [
            _vm._v("Configuración de parámetros"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Autoridad Certificante Intermedia"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control is-expanded" }, [
              _c("div", { staticClass: "select is-fullwidth" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.settings.autoridad_certificante_id,
                        expression: "settings.autoridad_certificante_id",
                        modifiers: { number: true },
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true },
                        expression: "{required:true}",
                      },
                    ],
                    attrs: { name: "AC Intermedia" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return _vm._n(val)
                          })
                        _vm.$set(
                          _vm.settings,
                          "autoridad_certificante_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.acDisponibles, function (autoridad) {
                    return _c(
                      "option",
                      {
                        key: `ac-id-${autoridad.id}`,
                        domProps: { value: autoridad.id },
                      },
                      [_vm._v(_vm._s(autoridad.nombre))]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.errors.has("AC Intermedia")
                ? _c("span", { staticClass: "help is-danger" }, [
                    _vm._v(_vm._s(_vm.errors.first("AC Intermedia"))),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "label" }, [
              _vm._v("Instrucciones para el suscriptor"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "control" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.settings.instrucciones,
                    expression: "settings.instrucciones",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required:true}",
                  },
                ],
                staticClass: "textarea",
                attrs: { name: "Instrucciones" },
                domProps: { value: _vm.settings.instrucciones },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.settings, "instrucciones", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _vm.errors.has("Instrucciones")
              ? _c("span", { staticClass: "help is-danger" }, [
                  _vm._v(_vm._s(_vm.errors.first("Instrucciones"))),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-9" },
              [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Patrón de acta"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "field has-addons" }, [
                    _c("div", { staticClass: "control is-expanded" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|regex:#at",
                            expression: "'required|regex:#at'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.settings.patron_actas,
                            expression: "settings.patron_actas",
                          },
                        ],
                        staticClass: "input",
                        class: { "is-danger": _vm.errors.has("patronActa") },
                        attrs: { type: "text", name: "patronActa" },
                        domProps: { value: _vm.settings.patron_actas },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.settings,
                              "patron_actas",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "control" }, [
                      _c("a", { staticClass: "button is-static" }, [
                        _vm._v(".pdf"),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "b-notification",
                  {
                    attrs: {
                      type: "is-warning is-light mt-5 py-3 px-4",
                      closable: false,
                    },
                  },
                  [
                    _vm._v(
                      "\n            Se debe incluir el flag #at obligatoriamente y garantizar que el nombre del acta sea único.\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "column content is-small" }, [
              _c("table", { staticClass: "table is-narrow mt-3" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { colspan: "2" } }, [
                      _vm._v("Patrones disponibles"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v("#at")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Tipo de acta")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#d")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Día")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#m")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Mes")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#Y")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Año")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#H")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Hora")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#i")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Minutos")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#s")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Segundos")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#ucf")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("CUIT del firmador")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#ucb")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("CUIT del beneficiario")]),
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("#ns")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Número de serie del certificado")]),
                  ]),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "field" },
            [
              _c("label", { staticClass: "label" }, [
                _vm._v("Carpeta de actas de la autoridad de registro"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c(
                    "a",
                    {
                      staticClass:
                        "button is-static is-fullwidth has-text-left",
                    },
                    [_vm._v(_vm._s(_vm.getRuta))]
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "help" }, [
                  _vm._v("Elija la carpeta donde se guardaran las actas."),
                ]),
                _vm._v(" "),
                _vm.errors.has("Carpeta de actas")
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("Carpeta de actas"))),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("explorer", {
                ref: "listado",
                attrs: {
                  idFolder: _vm.settings.origen_id || _vm.organizacion.slug,
                  rutas: _vm.rutas,
                  selected: _vm.selected,
                },
                on: {
                  "update:rutas": function ($event) {
                    _vm.rutas = $event
                  },
                  "update:selected": function ($event) {
                    _vm.selected = $event
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{required:true}",
                  },
                ],
                attrs: { type: "hidden", name: "Carpeta de actas" },
                domProps: { value: _vm.getIdRuta },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "field" }, [
            _c("div", { staticClass: "notification is-primary" }, [
              _c("i", { staticClass: "fas fa-info-circle fa-fw" }),
              _vm._v(" Recuerde asignar los roles "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Oficial de Registro"),
              ]),
              _vm._v(" y "),
              _c("span", { staticClass: "tag is-white is-rounded" }, [
                _vm._v("Suscriptor"),
              ]),
              _vm._v(
                "  a los usuarios para que utilicen la funcionalidad.\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "field is-clearfix" }, [
            _c("div", { staticClass: "buttons is-pulled-right" }, [
              _c(
                "button",
                {
                  staticClass: "button is-dark is-outlined",
                  on: { click: _vm.cancelar },
                },
                [_vm._v("\n            Cancelar\n          ")]
              ),
              _vm._v(" "),
              _vm.params
                ? _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      attrs: { disabled: _vm.errors.count() > 0 },
                      on: { click: _vm.reinstalar },
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      on: { click: _vm.instalar },
                    },
                    [_vm._v("\n            Instalar módulo\n          ")]
                  ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }